package com.essntl.core.network

actual val currentPlatform: Platform
    get() = Platform.Web